// Merkezi hata ve log yönetimi
export const errorHandler = {
    // Hata yönetimi
    handleError: (error: any, context?: string) => {
        // Sessizce hataları yönet
        if (process.env.NODE_ENV !== 'production') {
            // Development ortamında bile hataları gösterme
            return;
        }
    },

    // Log yönetimi
    log: (...args: any[]) => {
        // Tüm logları sessizce yok say
        return;
    },

    // Uyarı yönetimi
    warn: (...args: any[]) => {
        // Tüm uyarıları sessizce yok say
        return;
    },

    // Debug yönetimi
    debug: (...args: any[]) => {
        // Tüm debug mesajlarını sessizce yok say
        return;
    }
}; 